import * as yup from 'yup';

export const commonEstimatedUnbillFigureValidation: { [x: string]: any; } = {
    year: yup.number().required("Missing.")
        .min(1900, "Year should be range from 1900 to 2999.")
        .max(2999, "Year should be range from 1900 to 2999."),
    month: yup.number().required("Missing.")
        .min(1, "Month should be range from 1 to 12.")
        .max(12, "Month should be range from 1 to 12."),
    amount: yup.number().required("Missing."),
};

export const createEstimatedUnbillFigureValidation: { [x: string]: any; } = {
    ...commonEstimatedUnbillFigureValidation,
};

export const createEstimatedUnbillFigureValidationSchema = yup.object().shape(createEstimatedUnbillFigureValidation);

